import { useMemo } from 'react';
import {
  GetOptions, MakeRequestHookConfig, UseRequestFactory, useRequestFactory,
} from '../../../uc-api-sdk/staticFiles/useReqHook';
import { RewriteWithAIRequestParams } from '../types';
import { rewriteWithAIServices } from '../RewriteWithAIServices';

export const useRewriteMessage = <RCN = undefined>(
  configs?: MakeRequestHookConfig<RewriteWithAIRequestParams, GetOptions, RCN>,
) => {
  const baseConfigs: UseRequestFactory<
    RewriteWithAIRequestParams,
    string,
    typeof rewriteWithAIServices.getRewritedMessage,
    GetOptions,
    string
  > = useMemo(() => ({
    reqFunc: (...args: Parameters<typeof rewriteWithAIServices.getRewritedMessage>) => (
      rewriteWithAIServices.getRewritedMessage(...args)
    ),
    ResponseClassCreator: rewriteWithAIServices.getResponse,
    typeName: 'useRewriteMessage',
  }), []);

  return useRequestFactory(baseConfigs, configs);
};
